module.exports = __webpack_public_path__ + "img/1726035648642-screenshot-1726035488169.png.9fbb9a75.webp";